class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.form = this.querySelector('form');
    this.content = this.querySelector('[data-search-autocomplete]');
    this.queries = this.querySelector('[data-search-drawer-queries]');
    this.input = this.querySelector('input[type="search"]');
    this.suggested = this.dataset.searchSuggested;
    this.heading = this.querySelector('[data-search-drawer-heading]');
    this.result = this.querySelector('[data-search-drawer-result]');
    this.bottom = this.querySelector('[data-search-drawer-bottom]');
    this.allPredictiveSearchInstances = document.querySelectorAll('search-form');

    this.abortController = new AbortController();
    this.searchTerm = '';

    this.debouncedOnSubmit = debounce((event) => {
      this.result.classList.add('is-loading');
      this.onSubmitHandler(event);
    }, 500);
    this.form.addEventListener('input', this.debouncedOnSubmit.bind(this));
    // this.form.addEventListener('submit', function(event){
    //   event.preventDefault();
    //   const formData = new FormData(event.target.closest('form'));
    //   const searchParams = new URLSearchParams(formData).toString();
    //   const searchUrl = searchParams.split('&product_type=');
    //   const searchTerms = searchUrl[0].trim();
    //   const searchType = searchUrl[1] ? searchUrl[1].trim() : '*';
      
    //   const url = (searchType === '*') ? `/search?${searchTerms}` : `/search?${searchTerms}+product_type:${searchType}`;
      
    //   location.href = url;
    // });
  }

  getQuery() {
    return this.input.value.trim();
  }
  
  onSubmitHandler(event) {
    event.preventDefault();
    
    const newSearchTerm = this.getQuery();
    if (this.content.dataset.searchAutocomplete === 'true') {
      if (this.input.value == '' && this.suggested === 'true') {
      	this.heading.classList.add('search-suggested');
        this.result.classList.add('search-suggested');
        this.bottom.classList.add('search-suggested');
        this.queries.classList.add('search-suggested');
        this.result.classList.remove('is-loading');
      } else {
        if (this.suggested === 'true') {
          this.heading.classList.remove('search-suggested');
          this.result.classList.remove('search-suggested');
          this.bottom.classList.remove('search-suggested');
          this.queries.classList.remove('search-suggested');
        }
        this.renderPage(newSearchTerm);
      }
    }
  }
  
  renderPage(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    console.log(this.cachedResults);
    if (this.cachedResults[queryKey]) {
      this.renderProductGrid(this.cachedResults[queryKey]);
      return;
    }
    this.renderSectionFromFetch(searchTerm, queryKey);
  }
  
  renderSectionFromFetch(searchTerm, queryKey) {
    fetch(
      `/search/suggest?q=${encodeURIComponent(
        searchTerm
      )}&section_id=predictive-search`,
      { signal: this.abortController.signal }
    )
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
      this.allPredictiveSearchInstances.forEach(
        (predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        }
      );
      this.renderProductGrid(resultsMarkup);
    })
    .catch((error) => {
      if (error?.code === 20) {
        return;
      }
      throw error;
    });
  }
  renderProductGrid(html) {
    const contentProduct = html.querySelector('.search-results__product');
    this.result.classList.remove('is-loading');
    if (this.queries) {
      this.queries.innerHTML = html.querySelector('[data-search-drawer-queries]').innerHTML;
    }
    this.content.innerHTML = contentProduct.innerHTML;
  }
}
customElements.define('search-form', SearchForm);